/* HeyBear · Reviews: video cards carousel + the car driving along the hill line. */
HB.section('reviews', function (root) {
  var $ = function (s) { return root.querySelector(s); };
  var off = [], raf = 0;
  var on = function (el, ev, fn, o) { if (!el) return; el.addEventListener(ev, fn, o); off.push(function () { el.removeEventListener(ev, fn, o); }); };
  HB.reveal(root);
  var track = $('#ugcTrack'), rail = $('#ugcRail'); if (!track) return;
  /* Cards stay poster-first; desktop hover/focus may preview one muted video at a time. */
  var visibilityObserver, activeVideo = null, activeVimeoCard = null, activePreviewCard = null;
  var supportsHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var cards = [].slice.call(track.querySelectorAll('.vid'));
  var setButton = function (card, playingWithSound) {
    var button = card.querySelector('.vid-toggle'); if (!button) return;
    button.setAttribute('aria-pressed', playingWithSound ? 'true' : 'false');
    button.setAttribute('aria-label', (playingWithSound ? 'Pause ' : 'Play ') + card.getAttribute('aria-label') + (playingWithSound ? '' : ' with sound'));
    card.classList.toggle('is-playing-sound', playingWithSound);
  };
  var resetNativeVideo = function (card) {
    var video = card.querySelector('video');
    if (!video) return;
    video.pause();
    video.muted = true;
    if (video === activeVideo) activeVideo = null;
    setButton(card, false);
    if (video.currentTime || video.readyState) {
      try { video.currentTime = 0; } catch (e) {}
      video.load();
    }
  };
  var vimeoSrc = function (id, preview) {
    var params = preview
      ? 'background=1&autoplay=1&muted=1&loop=1&autopause=0&controls=0&dnt=1&playsinline=1'
      : 'autoplay=1&title=0&byline=0&portrait=0&dnt=1&playsinline=1';
    return 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?' + params;
  };
  var makeVimeoFrame = function (card, id, preview) {
    var iframe = document.createElement('iframe');
    iframe.className = preview ? 'vid-vimeo-preview-player' : 'vid-vimeo-player';
    iframe.src = vimeoSrc(id, preview);
    iframe.title = preview ? card.getAttribute('aria-label') + ' muted preview' : card.getAttribute('aria-label');
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.setAttribute('allowfullscreen', '');
    if (preview) {
      iframe.tabIndex = -1;
      iframe.setAttribute('aria-hidden', 'true');
    }
    return iframe;
  };
  var startVimeoPreview = function (card) {
    if (HB.reduce || card.classList.contains('is-vimeo-playing')) return;
    var holder = card.querySelector('[data-vimeo-preview]');
    var button = card.querySelector('[data-vimeo-id]');
    var id = button && button.getAttribute('data-vimeo-id');
    if (!holder || !id || holder.querySelector('iframe')) return;
    var iframe = makeVimeoFrame(card, id, true);
    iframe.addEventListener('load', function () {
      if (iframe.isConnected && holder.contains(iframe)) card.classList.add('is-vimeo-preview-ready');
    }, { once: true });
    holder.appendChild(iframe);
  };
  var stopVimeoPreview = function (card) {
    var iframe = card.querySelector('.vid-vimeo-preview-player');
    if (iframe) iframe.remove();
    card.classList.remove('is-vimeo-preview-ready');
  };
  var stopVimeoPlayer = function (card) {
    var iframe = card.querySelector('.vid-vimeo-player');
    if (iframe) iframe.remove();
    card.classList.remove('is-vimeo-playing');
    var button = card.querySelector('[data-vimeo-id]');
    if (button) button.hidden = false;
    if (activeVimeoCard === card) activeVimeoCard = null;
  };
  var stopCardPreview = function (card) {
    if (!card) return;
    if (card.querySelector('[data-vimeo-id]')) {
      if (!card.classList.contains('is-vimeo-playing')) stopVimeoPreview(card);
    } else {
      var video = card.querySelector('video');
      if (video && video !== activeVideo) resetNativeVideo(card);
    }
    if (activePreviewCard === card) activePreviewCard = null;
  };
  var startCardPreview = function (card) {
    if (!card || HB.reduce || activeVideo || activeVimeoCard || activePreviewCard === card) return;
    if (activePreviewCard) stopCardPreview(activePreviewCard);
    activePreviewCard = card;
    if (card.querySelector('[data-vimeo-id]')) {
      startVimeoPreview(card);
      return;
    }
    var video = card.querySelector('video');
    if (!video) { activePreviewCard = null; return; }
    video.muted = true;
    video.play().catch(function () {
      if (activePreviewCard === card) activePreviewCard = null;
    });
  };
  var stopOtherPlayback = function (currentCard) {
    cards.forEach(function (otherCard) {
      if (otherCard === currentCard) return;
      stopCardPreview(otherCard);
      if (otherCard.classList.contains('is-vimeo-playing')) stopVimeoPlayer(otherCard);
      resetNativeVideo(otherCard);
    });
    activePreviewCard = null;
  };
  cards.forEach(function (card) {
    var video = card.querySelector('video'), button = card.querySelector('.vid-toggle');
    var vimeoId = button && button.getAttribute('data-vimeo-id');
    if (!button) return;
    if (supportsHover) {
      on(card, 'pointerenter', function () { startCardPreview(card); });
      on(card, 'pointerleave', function () { stopCardPreview(card); });
      on(button, 'focus', function () { startCardPreview(card); });
      on(button, 'blur', function () { stopCardPreview(card); });
    }
    if (vimeoId) {
      on(button, 'click', function () {
        if (card.classList.contains('is-vimeo-playing')) return;
        stopOtherPlayback(card);
        activeVideo = null;
        stopVimeoPreview(card);

        var iframe = makeVimeoFrame(card, vimeoId, false);
        card.insertBefore(iframe, button);
        card.classList.add('is-vimeo-playing');
        activeVimeoCard = card;
        button.hidden = true;
      });
      return;
    }
    if (!video) return;
    video.muted = true;
    video.loop = true;
    video.setAttribute('playsinline', '');
    on(button, 'click', function () {
      if (activeVideo === video && !video.paused) {
        resetNativeVideo(card);
        return;
      }
      stopOtherPlayback(card);
      stopCardPreview(card);
      video.muted = false;
      video.play().then(function () {
        activeVideo = video;
        setButton(card, true);
      }).catch(function () {
        resetNativeVideo(card);
      });
    });
  });
  if ('IntersectionObserver' in window) {
    visibilityObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) return;
        var card = entry.target;
        var video = card.querySelector('video');
        stopCardPreview(card);
        if (card.classList.contains('is-vimeo-playing')) stopVimeoPlayer(card);
        if (video && video === activeVideo) resetNativeVideo(card);
      });
    }, { threshold: .01 });
    cards.forEach(function (card) {
      if (card.querySelector('video') || card.querySelector('[data-vimeo-id]')) visibilityObserver.observe(card);
    });
  }
  /* car follows the top edge of the middle hill as you scroll */
  (function () {
    var car = $('#hillCar'), line = $('#hillLine'), hills = $('.hills'); if (!car || !line) return;
    var L = line.getTotalLength(), VW = 1440, VH = 260, N = 240, pts = [];
    for (var i = 0; i <= N; i++) { var p = line.getPointAtLength(L * i / N); pts.push([p.x, p.y]); }
    var yAt = function (vx) { var i = pts.findIndex(function (p) { return p[0] >= vx; }); if (i <= 0) return pts[Math.max(0, i)][1]; var a = pts[i - 1], b = pts[i], t = (vx - a[0]) / (b[0] - a[0] || 1); return a[1] + (b[1] - a[1]) * t; };
    var cur = null;
    function target() { var r = hills.getBoundingClientRect(); return Math.min(1, Math.max(0, (innerHeight - r.top) / (innerHeight * .9 + r.height * .2))); }
    function draw(p) {
      var W = hills.clientWidth, H = hills.clientHeight, cw = car.offsetWidth, ch = car.offsetHeight;
      var x = W + cw * .3 - p * (W + cw * .6); /* drives right to left */
      var vx = Math.min(VW, Math.max(0, x / W * VW)), d = 6;
      var y = yAt(vx) / VH * H;
      var y1 = yAt(Math.max(0, vx - d)) / VH * H, y2 = yAt(Math.min(VW, vx + d)) / VH * H;
      var ang = Math.atan2(y2 - y1, (2 * d) / VW * W) * 180 / Math.PI;
      car.style.transform = 'translate(' + (x - cw / 2) + 'px,' + (y - ch * .94 + 2) + 'px) rotate(' + ang.toFixed(2) + 'deg)';
    }
    function loop() { var t = target(); cur = cur == null || HB.reduce ? t : cur + (t - cur) * .12; draw(cur); raf = requestAnimationFrame(loop); }
    raf = requestAnimationFrame(loop);
  })();
  var step = function () { var c = track.querySelector('.vid'); return c ? c.offsetWidth + 16 : 260; };
  on($('#ugcPrev'), 'click', function () { rail.scrollBy({ left: -step() * 2, behavior: HB.reduce ? 'auto' : 'smooth' }); });
  on($('#ugcNext'), 'click', function () { rail.scrollBy({ left: step() * 2, behavior: HB.reduce ? 'auto' : 'smooth' }); });
  /* start slightly scrolled so cards bleed both edges */
  requestAnimationFrame(function () { rail.scrollLeft = Math.max(0, (track.scrollWidth - rail.clientWidth) / 2 - step() * 1.5); });
  return function () {
    cancelAnimationFrame(raf);
    if (visibilityObserver) visibilityObserver.disconnect();
    cards.forEach(function (card) {
      resetNativeVideo(card);
      stopVimeoPreview(card);
      stopVimeoPlayer(card);
    });
    off.forEach(function (f) { f(); });
  };
});
